import { Collection } from '../../models/Collection';
import { IKeyValPair } from '../../models/StateModels';

const _TypedToJSON = (typed: any): object => {
  if (Array.isArray(typed)) {
    return typed.map((v) => (v && typeof v === 'object' ? _TypedToJSON(v) : v));
  } else {
    return Object.entries(typed)
      .filter(([_, v]) => v !== undefined && typeof v !== 'function')
      .reduce(
        (acc, [k, v]) => ({
          ...acc,
          [k]: v === Object(v) ? _TypedToJSON(v) : v,
        }),
        {}
      );
  }
};

const _CastTyped = <T>(input: any): T => (input as unknown) as T;

const _ObjectToIKeyValPair = (params: object | null | undefined): IKeyValPair[] => {
  if (params === null || params === undefined) return [];
  return Object.entries(params).map(([k, v]) => ({ Anahtar: k, Deger: v }));
};

export const Conversions = {
  TypedToJSON: _TypedToJSON,
  CastTyped: _CastTyped,
  ObjectToIKeyValPair: _ObjectToIKeyValPair,
};
